import type { ArmorPassive } from "@hd2/data";
import { useEffect, useState } from "react";

let cache: ArmorPassive[] | null = null;
let pending: Promise<ArmorPassive[]> | null = null;

async function fetchArmorPassives(): Promise<ArmorPassive[]> {
	if (cache) {
		return cache;
	}
	if (!pending) {
		pending = fetch("/api/armor-passives")
			.then((r) => r.json() as Promise<{ passives: ArmorPassive[] }>)
			.then((data) => {
				cache = data.passives;
				return cache;
			});
	}
	return pending;
}

export function useArmorPassives(): {
	passives: ArmorPassive[];
	loading: boolean;
} {
	const [passives, setPassives] = useState<ArmorPassive[]>(() => cache ?? []);
	const [loading, setLoading] = useState(cache === null);

	useEffect(() => {
		if (cache) {
			setPassives(cache);
			setLoading(false);
			return;
		}
		let alive = true;
		fetchArmorPassives()
			.then((list) => {
				if (alive) {
					setPassives(list);
					setLoading(false);
				}
			})
			.catch(() => {
				if (alive) {
					setLoading(false);
				}
			});
		return () => {
			alive = false;
		};
	}, []);

	return { passives, loading };
}
